<template>
  <div>
    <v-tooltip :text="$t('messages.switchTheme')">
      <template v-slot:activator="{ props }">
        <v-btn v-bind="props" icon flat @click="switchTheme()">
          <v-icon style="color: lightgray">mdi-brightness-6</v-icon>
        </v-btn>
      </template>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "themePicker",

  data() {
    return {
      themes: [],
    };
  },

  methods: {
    switchTheme() {
      if (this.themes.length > 0) {
        let currTheme = this.$store.state.theme;
        let index = this.themes.indexOf(currTheme);
        if (index >= 0) {
          if (index < this.themes.length - 1) {
            this.$store.dispatch("setTheme", this.themes[index + 1]);
            window.location.reload();
            return;
          } else {
            this.$store.dispatch("setTheme", this.themes[0]);
            window.location.reload();
            return;
          }
        }

        this.$store.dispatch("setTheme", this.themes[0]);
        window.location.reload();
        return;
      }
    },
  },

  mounted() {
    this.themes = [];
    for (let i in this.$vuetify.theme.themes) {
      if (typeof i == "string" && i.startsWith("custom")) {
        this.themes.push(i);
      }
    }
  },
};
</script>
